import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton, Tooltip, Chip } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { Add as AddIcon, AdminPanelSettings as AdminIcon, Feedback as FeedbackIcon, Home as HomeIcon, Payment as PaymentIcon } from '@mui/icons-material';
import RechargeDialog from './RechargeDialog';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onExport: () => void;
  isNormalizing: boolean;
}

const Header: React.FC<HeaderProps> = ({ onExport, isNormalizing }) => {
  const { user, logout } = useAuth();
  const [rechargeDialogOpen, setRechargeDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenRechargeDialog = () => {
    setRechargeDialogOpen(true);
  };

  const handleCloseRechargeDialog = () => {
    setRechargeDialogOpen(false);
  };

  const isAdmin = user?.email === 'ngoclinh15994@gmail.com';

  const handleFeedbackClick = () => {
    window.open('https://forms.gle/6hjykaJwJ3ostv969', '_blank');
  };

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  const handlePaymentClick = () => {
    navigate('/payment');
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              flexGrow: 1, 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                opacity: 0.8
              }
            }}
            onClick={handleLogoClick}
          >
            <HomeIcon />
            Chuẩn hóa địa chỉ Sapo
          </Typography>
          {user && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Button
                color="inherit"
                startIcon={<FeedbackIcon />}
                onClick={handleFeedbackClick}
              >
                Feedback
              </Button>
              <Button
                color="inherit"
                startIcon={<PaymentIcon />}
                onClick={handlePaymentClick}
              >
                Nâng cấp
              </Button>
              {isAdmin && (
                <Button
                  color="inherit"
                  startIcon={<AdminIcon />}
                  onClick={() => navigate('/admin')}
                >
                  Admin
                </Button>
              )}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2">
                  {user.email}
                </Typography>
                <Chip 
                  label={`${user.greenCoins} 🟢`} 
                  size="small" 
                  sx={{ 
                    color: 'rgb(0, 255, 13)',
                    borderColor: 'rgb(0, 255, 13)',
                    '& .MuiChip-label': {
                      color: 'rgb(0, 255, 13)'
                    }
                  }}
                  variant="outlined"
                />
                <Chip 
                  label={`${user.goldCoins} 🟡`} 
                  size="small" 
                  color="warning" 
                  variant="outlined"
                />
                <Chip 
                  label={user.packageType === 'GOLD' ? 'Premium' : 'Cơ bản'} 
                  size="small" 
                  color={user.packageType === 'GOLD' ? 'warning' : 'default'} 
                  variant="outlined"
                />
              </Box>
              <Button color="inherit" onClick={logout}>
                Đăng xuất
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {user && (
        <RechargeDialog
          open={rechargeDialogOpen}
          onClose={handleCloseRechargeDialog}
          userEmail={user.email}
        />
      )}
    </>
  );
};

export default Header; 